import { shuffle } from './shuffle'

/**
 * Generate a random password with the given criteria. Based on https://stackoverflow.com/a/43020177
 *
 * @param lowerCaseLetters How many lower case letters the password should contain.
 * @param upperCaseLetters How many upper case letters the password should contain.
 * @param numbers How many numbers the password should contain.
 * @param symbols How many symbols the password should contain.
 * @param either How many mixed characters (but no more symbols) the password should contain.
 */
export function generateRandomPassword(
  lowerCaseLetters: number,
  upperCaseLetters: number,
  numbers: number,
  symbols: number,
  either: number
): string {
  const chars = [
    'abcdefghijklmnopqrstuvwxyz', // lower case letters
    'ABCDEFGHIJKLMNOPQRSTUVWXYZ', // upper case letters
    '0123456789', // numbers
    '+-_$', // symbols
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789', // either
  ]

  const password = [lowerCaseLetters, upperCaseLetters, numbers, symbols, either]
    .map((len, i) =>
      Array(len)
        .fill(chars[i])
        .map(x => x[Math.floor(Math.random() * x.length)])
        .join('')
    )
    .concat()
    .join('')
    .split('')

  return shuffle(password).join('')
}
